import { styled } from '@mui/material/styles';
import { IconButton } from 'components/buttons';
import { SelectField } from 'components/inputs';
import { FormRow, FormItem } from 'components/styledComponents';

export const FixedSection = styled('div')(() => ({
  display: 'flex',
  flexWrap: 'nowrap',
  flexGrow: 1
}));

export const DeleteButton = styled(IconButton)(({ theme }) => ({
  /**
   * @TODO find a better way for spacing
   * https://jira.atreus.de/browse/MILK-643
   */
  alignSelf: 'flex-start',
  margin: theme.spacing(0.875, 0, 0.875, 1),
  flexGrow: 0,

  color: theme.color.danger.main,
  border: `1px solid transparent`,

  '&:hover': {
    border: `1px solid ${theme.color.danger.main}`
  },
  '&:active': {
    border: `1px solid ${theme.color.danger.main}`
  }
}));

export const TypeSelector = styled(SelectField)(() => ({
  flexGrow: 1,
  minWidth: '200px'
}));

export const StyledFormRow = styled(FormRow, {
  shouldForwardProp: prop => prop !== 'rowReverse' // prevent invalid DOM prop warning
})(({ rowReverse }) => ({
  ...(rowReverse && {
    flexDirection: 'row-reverse !important',
    marginBottom: '15px'
  })
}));

export const StyledFormItem = styled(FormItem, {
  shouldForwardProp: prop => prop !== 'content' // prevent invalid DOM prop warning
})(({ theme, content }) => ({
  margin: '0px !important',
  '&:after': {
    color: theme.color.primary.main,
    content: content ? `'${content}'` : '""', // always valid CSS string
    fontSize: 'small',
    position: 'absolute',
    bottom: '-20px',
    left: '5px'
  }
}));

export const FormItemWrapper = styled('div')(() => ({
  display: 'flex',
  padding: '12px 8px'
}));
